module.exports = __webpack_public_path__ + "static/media/599.756(5).68c9a09a.pdf";